import React from 'react';
import styles from './ContentLibrary.module.css';

const CONTENT = [
  {
    source: 'startingstrength.com',
    sourceLabel: 'Article',
    items: [
      { title: 'The Novice Effect', url: 'https://example.com/ss-article-placeholder-1' },
      { title: 'Why Barbells?', url: 'https://example.com/ss-article-placeholder-2' },
    ],
  },
  {
    source: 'SSG YouTube',
    sourceLabel: 'Video',
    items: [
      { title: 'SS Gyms Member Spotlight', url: 'https://example.com/ssg-youtube-placeholder-1' },
      { title: 'Coaching Cues That Work', url: 'https://example.com/ssg-youtube-placeholder-2' },
    ],
  },
  {
    source: 'Starting Strength YouTube',
    sourceLabel: 'Video',
    items: [
      { title: 'The Low Bar Squat', url: 'https://example.com/ss-youtube-placeholder-1' },
      { title: 'Rippetoe on Progression', url: 'https://example.com/ss-youtube-placeholder-2' },
    ],
  },
];

const ContentLibrary = () => (
  <div className={styles.ContentLibrary}>
    <h3 className={styles.Title}>Content Library</h3>
    {CONTENT.map(section => (
      <div key={section.source} className={styles.Section}>
        <p className={styles.SectionLabel}>{section.source}</p>
        {section.items.map(item => (
          <a
            key={item.url}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.Item}
          >
            <span className={styles.ItemTitle}>{item.title}</span>
            <span className={styles.ItemTag}>{section.sourceLabel}</span>
          </a>
        ))}
      </div>
    ))}
  </div>
);

export default ContentLibrary;
